import odnoklassniki from '@r1-frontend/ui-react/organisms/Footer/components/icons/odnoklassniki.svg';
import telegram from '@r1-frontend/ui-react/organisms/Footer/components/icons/telegram.svg';
import vkontakte from '@r1-frontend/ui-react/organisms/Footer/components/icons/vkontakte.svg';

export const SOCIALS = [
    { link: 'https://vk.com/domru', background: 'white', img: vkontakte },
    { link: 'https://ok.ru/domru', background: 'white', img: odnoklassniki },
    { link: 'https://t.me/domru_official', background: 'white', img: telegram },
];

export const APP_IMG_SRC = '/static/images/service/contact/app-desktop';
